import React, { Component } from 'react';
import { properties } from '../properties.js';
import Web3 from 'web3';
import standard_abiA from '../../abis/Standard16A-abi.json';
import Navbar from "../LogInNavBar.js";
import Footer from "../Footer.js";
import { Carousel } from 'react-responsive-carousel';
import { withTranslation } from 'react-i18next';
import './css_8/userCertificate.css';
import i18n from '../I18N/I18n.js'; 
import { logout, apiPublicRequest, apiSecuredRequest, cambiarIdioma, checkFileType, setBearer} from '../functions.js';



class QRNftDisplay extends Component {


    async componentDidMount() {
        await this.loadBrandFields()
        // 2. Carga de datos de la Blockchain
        await this.validateQRGeneratedUrl()

    }
    cambiarIdioma = (idioma) => {
        const { i18n } = this.props;
        i18n.changeLanguage(idioma); // Cambia el idioma usando i18n
    };

    async loadBrandFields() {
        let data = JSON.stringify({
            "email": `${properties.appUser}`,
            "password": `${properties.appPass}`
        });


        const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/login`, data);
        let urlParams = (new URL(document.location)).searchParams;
        const certificadoId = urlParams.get("certificadoId")
        let camposData = JSON.stringify({
            "certificadoId": `${certificadoId}`,
            "tipoStandard": `8CAMPOS`
        });
        const certificadoCompleto = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/empresas/certificado/${certificadoId}`, "", bearerToken.data.accessToken);
        this.setState({certificadoCompleto: certificadoCompleto.data});

       

        const campos = await await apiSecuredRequest(
            'post', 
            `${properties.apiUrl}/certificat/api/campo/getCampos`, 
            camposData, 
            bearerToken.data.accessToken
        );


        
        

        this.setState({ campos: campos.data })
    }


    async validateQRGeneratedUrl() {
        let urlParams = (new URL(document.location)).searchParams;
        this.setState({ params: urlParams });
        const nombre = urlParams.get("nombre");
        const apellido1 = urlParams.get("apellido1");
        const apellido2 = urlParams.get("apellido2");
        const email = urlParams.get("email");
        const idProducto = urlParams.get("idProducto");
        const account = urlParams.get("account");
        const documento = urlParams.get("documento");
       

        const abi = standard_abiA;
       
        console.log('abi', abi);
        const address = this.state.certificadoCompleto.direccion;
        
        const certificadoNombre = this.state.certificadoCompleto.certificado;
        if(abi && address) {
            try {
                var web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
                const contract = new web3.eth.Contract(abi, address);
            
                const userNfts = await contract.methods.getOwnerProductData().call({ from: account });
                const validatedNFT = userNfts.filter(nft => nft.idProducto == `${idProducto}`)[0];
               


                const hashValidation = await contract.methods.checkUserInfo(nombre, apellido1, apellido2, email, documento,
                    validatedNFT.campoNumerico,
                    validatedNFT.modelo,
                    validatedNFT.idProducto).call({ from: account });

                if (hashValidation == false) {
                    Swal.fire({
                        icon: 'error',
                        title: 'User data does not match certificate data',
                        text: 'Something went wrong!'
                    });
                } else {
                    let tipoArchivo1 = await checkFileType(validatedNFT.tokenUri);
				this.setState({tipoArchivo1})

                    this.setState({ nftURL: validatedNFT.tokenUri });
                    this.setState({ nombre });
                    this.setState({ apellido1 });
                    this.setState({ apellido2 });
                    this.setState({ documento });
                    this.setState({ email });
                    this.setState({ numerico: validatedNFT.campoNumerico.toString() });
                    this.setState({ descripcion: validatedNFT.descripcion });
                    this.setState({ idProducto: validatedNFT.idProducto });
                    this.setState({ account });
                    this.setState({ campoFecha: validatedNFT.campoFecha });
                    this.setState({ userInfo: validatedNFT.userInfo });
                    this.setState({ modelo: validatedNFT.modelo });
                    this.setState({ showData: true });
                    this.setState({ certificadoNombre: certificadoNombre });
                    
                }

            } catch (err) {
                this.setState({ errorMessage: err })
            } finally {
                this.setState({ loading: false })
            }
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            account: null,
            nombre: "",
            apellido1: null,
            apellido2: true,
            email: null,
            documento: null,
            numerico: null,
            tipoArchivo1: null,
            descripcion: null,
            idProducto: null,
            campoFecha: false,
            showData: false,
            userInfo: null,
            modelo: null,
            certificadoNombre: null,
            nftURL: null,
            campos: null,
            empresa: null
        }
    }

    render() {
        if (this.state.nftURL != null && this.state.certificadoNombre != null) {
            const campoNumerico = this.state.campos.filter(campo => campo.orden == "NUMERICO")[0].nombreCampo;
				const campoFecha = this.state.campos.filter(campo => campo.orden == "FECHA")[0].nombreCampo;
				const idProducto = this.state.campos.filter(campo => campo.orden == "IDPRODUCTO")[0].nombreCampo;
            return (
                <>
                    <Navbar mail={this.state.email} cambiarIdioma = {this.cambiarIdioma} />

                    <div className="nft_display_16">

<p onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard16/userCertificateList?empresaId=${this.state.empresaId}&empresaName=${this.state.empresaName}` }} className="menu_brandName_16"><span>{this.state.empresaName} /</span>
    <button onClick={(event) => { window.location.href = `/standard16/listaEmpresas` }} className="allBrands_btn_16">{i18n.t('AllCertificates')}</button></p>
    <div className="nftDisplay_imgItem_16">
             
		    	<div>
			    	<img src={this.state.tipoArchivo1} width="250px" alt="NFT 1" />
				</div>
			
			
    </div>                     

<div className="content_info_16">

    <p className="product_model_16">{this.state.modelo}</p>
    

    <div className="details_container_16">
        <div className="certificateData_card_1">
            <p className="titleCard_16">{i18n.t('CertificateData')}</p>
            <table className="productDetails_table_16">
                
                    <tr>
                        <th className="details_th_16">{i18n.t('Name')}:</th>
                        <td className="details_td_16">{this.state.nombre}</td>
                    </tr>
                    <tr>
                        <th className="details_th_16">{i18n.t('Surname')}:</th>
                        <td className="details_td_16">{this.state.apellido1}&nbsp;{this.state.apellido2}</td>
                    </tr>

                    <tr>
                        <th className="details_th_16">{i18n.t('Email')}:</th>
                        <td className="details_td_16">{this.state.email}</td>
                    </tr>

                    <tr>
                        <th className="details_th_16">{i18n.t('documento')}:</th>
					    <td className="details_td_16">{this.state.documento}</td>
					</tr>								
                    <tr>
                        <th className="details_th_16">{i18n.t('WalletAddress')}:</th>
                        <td className="details_td_16"><a className="product_walletAdress_16" href='https://etherscan.io/address/${account}'>{this.state.account}</a></td>
                    </tr>
                    <tr>
                        <th className="details_th_16">{i18n.t('UserHash')}</th>
                        <td className="details_td_16">{this.state.userInfo}</td>
                    </tr>
                    <tr>
                        <th className="details_th_16">{i18n.t('Model')}</th>
                        <td className="details_td_16">{this.state.modelo}</td>
                    </tr>
                

                <tr>
                    <th className="details_th_16">{idProducto}</th>
                    <td className="details_td_16">{this.state.idProducto}</td>
                </tr>
                <tr>
                    <th className="details_th_16">{campoFecha}</th>
                    <td className="details_td_16">{this.state.campoFecha}</td>
                </tr>
            </table>
        </div>
    </div>

    <div className="description_container_16">
        <p className="titleCard_16">{i18n.t('Model')}</p>
        <p class="product_description_16">{this.state.descripcion}</p>
    </div>
</div>
</div>

<Footer />
                </>
            );

        } else {
            <h1>Loading</h1>
        }


    }
}

export default  withTranslation()(QRNftDisplay);
